// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
import * as common_controller from "../commonController"

const content_type = "SalesLine"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "SalesId",
      label: "销售订单编号",
      sortable: true,
      width: "120px"
    },
    {
      key: "SalesPoolId",
      label: "池",
      width: "100px"
    },
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "dataAreaId",
      label: "公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    // {
    //   key: "SalesStatus",
    //   label: "行状态",
    //   sortable: true
    // },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "valid_remain",
      label: "剩余派单数量",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "SalesPrice",
      label: "单位价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SalesUnit",
      label: "单位",
      sortable: true
    },

    {
      key: "TaxItemGroup",
      label: "销售税(物料)组",
      sortable: true
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true,
      thStyle: { width: "10rem" },
      width: "10rem",
      type: "short"
    },
    {
      key: "Name",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,
      type: "date"
    },

    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "SDApprovedState",
      label: "派发审批状态",
      sortable: true,
      type: "state",
      context: ["待审批", "已审批"]
    }
  ],
  dicpatch_fields: [
    {
      key: "idnum",
      label: "派发编号",
      sortable: true,
      width: "60px",
      formatter: (value, key, item) => {
        return item.id
      }
    },
    {
      key: "AccountNum",
      label: "供应商编号",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "11rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "qty",
      label: "数量",
      editable: false,
      type: "just_number"
      // _precise: 6
    },

    {
      key: "price",
      label: "实际含税价",
      editable: false,
      type: "just_number"
    },
    {
      key: "PurchCurrencyCode",
      label: "实际含税价币种"
    },
    {
      key: "price_wotax",
      label: "实际采购本币净单价",
      type: "number",
      _precise: 6
    },
    {
      key: "price_remark",
      label: "价格备注",
      width: "8rem",
      type: "short"
    },
    {
      key: "price_vend",
      label: "初始含税报价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "price_vend_currency",
      label: "初始含税报价币种",
    },
    {
      key: "price_vend_wotax",
      label: "初始采购本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "Sales_Order_Price",
      label: "订单本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "VendTaxGroup",
      label: "供应商税组",
      sortable: true,
      thStyle: {
        width: "150px"
      }
    },
    {
      key: "quote_state",
      label: "价格状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "Cost_Sum",
      label: "供应商成本",
      type: "number"
    },
    {
      key: "Sales_Cost",
      label: "价格协议成本",
      type: "number"
    },
    {
      key: "profit_state",
      label: "毛利状态",
      sortable: true,
      type: "state_icon"
    },
    {
      key: "profit_value",
      label: "毛利",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "invent_sum",
      label: "现有库存量",
      type: "number",
      _precise: 6
    },
    {
      key: "delivery_date",
      label: "装运日期",
      editable: true,
      type: "date"
    },
    {
      key: "Capacity",
      label: "产能(天)",
      editable: true,
      type: "number"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },

    {
      key: "TotalScore",
      label: "评价",
      sortable: true,
      type: "rate",
      disabled: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "create_by_username",
      label: "派发创建人",
      sortable: true
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "Up_Approver",
      label: "前一级审批人",
      sortable: true
    },
    {
      key: "UpApproveRemark",
      label: "审批意见",
      sortable: true,
      width: "12rem",
      type: "html"
    },
    {
      key: "Approver",
      label: "当前审批人",
      sortable: true
    },
    {
      key: "ApproveRemark",
      label: "当前审批意见",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "fcCheckDocumentAllApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentAllApproved",
      other_type_key: "is_email_send",
      isCheckInApprove: true,
      context: ["待审批", "已审批", "审批中", "已退回"]
    },
    {
      key: "SDApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSDApproved) {
          item.SDApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SDApprovedState = "审批中"
          return "审批中"
        } else {
          item.SDApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "isAXError",
      label: "异常状态",
      sortable: true,
      type: "state_error",
      context: ["", "异常"]
    },
    {
      key: "AXError",
      label: "异常信息",
      sortable: true,
      type: "short",
      // thStyle: {
      //   width: "10rem"
      // }
    },
    {
      key: 'Accessory',
      label: '附件',
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-fujian",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
  ]
}

const dataForm = {
  id: "",
  saleOrder_num: "",
  cust_name: "",
  product_name: "",
  supplier_num: "",
  price: 0,
  price_wotax: 0,
  profit_value: 0,
  price_vend: 0,
  price_vend_wotax: 0,
  qty: 0,
  TaxGroup: "",
  delivery_date: new Date()
}

///前端验证
const rules = {}

const descriptor = {}
const methods = {
  ///get 派单详情
  async getDispatchItems(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      {},
      {}
    )
    let _fields = _.map(fields.dicpatch_fields, "key")
    _fields.push("id")
    _fields.push("is_deleted")
    _fields.push("SalesLineId")
    _fields.push("approved_at")
    _fields.push("AXSalesId")
    _fields.push("AXInventTransId")
    _fields.push("AXPurchId")
    _fields.push("AXPurchInventTransId")
    _fields.push("AXSalesLineNum")
    _fields.push("AXPurchLineNum")
    _fields.push("fcCheckSDApproved(t.id)")
    // _fields.push("fcGetSODispatchApprover(t.id)");
    _fields.push("AXInventTransRet")
    _fields.push("AXPurchInventTransRet")
    _fields.push("is_email_send")
    _fields.push("fcGetDocumentApprover('SalesOrderDispatch','',t.id)")
    _fields.push("fcCheckDocumentAllApproved('SalesOrderDispatch',t.id)")

    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get 派单详情
  async getDispatchItemsSql(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_dispatch_by_salesLine_id",
      {},
      {}
    )
    let _fields = _.map(fields.dicpatch_fields, "key")
    _fields.push("id")
    _fields.push("is_deleted")
    _fields.push("SalesLineId")
    _fields.push("approved_at")
    _fields.push("AXSalesId")
    _fields.push("AXInventTransId")
    _fields.push("AXPurchId")
    _fields.push("AXPurchInventTransId")
    _fields.push("AXSalesLineNum")
    _fields.push("AXPurchLineNum")
    _fields.push("fcCheckSDApproved(t.id)")
    _fields.push("fcGetDocumentApprover('SalesOrderDispatch','',t.id)")
    _fields.push("fcCheckDocumentAllApproved('SalesOrderDispatch',t.id)")
    _fields.push("AXInventTransRet")
    _fields.push("AXPurchInventTransRet")
    _fields.push("is_email_send")

    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get 订单明细
  async getData(_params) {
    const salesline_biz_data = new biz_data_helper.base_entity_helper(
      "get_dispatch_salesline",
      {},
      {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("id")
    _fields.push("valid_approve")
    _fields.push("SalesTable_id")
    _fields.push("AXInventTransId")
    _fields.push("AXPurchInventTransId")

    let result = await salesline_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    // let _fields = _.map(fields.default, "key");
    // _fields.push("id");
    // _fields.push("valid_approve");
    // _fields.push("SalesTable_id");
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _fields
    //   })
    //   .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///approve
  async approveDataNew(_params) {
    //1、审核派单
    //2、修改订单明细剩余数量
    //3、生成采购单
    //4、调用AX
    let _actions = []

    //1、审核派单
    if (_params.approve_data && !_.isNull(_params.approve_data)) {
      const update_status_biz_data = new biz_data_helper.base_entity_helper(
        "update_approve_status",
        {},
        {}
      )
      let approved_biz_data = new biz_data_helper.base_entity_helper(
        "update_sPlant_SalesOrder_Dispatch",
        {},
        {}
      )
      _.each(_params.approve_data, t => {
        _actions.push(
          update_status_biz_data
            .execAction({
              params: {
                IsApproved: t.is_approved == true ? 1 : 0,
                ApproveBy: t.username,
                status_id: t.id,
                ApproveRemark: t.ApproveRemark //审批备注
              },
              fields: ["is_update_ok", "is_all_approved"]
            })
            .action({
              output_last_item_map: {
                is_update_ok: "is_update_ok",
                is_all_approved: "is_all_approved"
              },
              rollback_when: {
                isApproved: {
                  "=": false
                }
              }
            })
        )
        if (!t.is_approved) {
          let _x = {
            SODispatchId: t.order_dispatch_id,
            CreateBy: t.userId,
            IsEmailSend: 0
          }
          _actions.push(
            approved_biz_data
              .execAction({
                params: _x
              })
              .action({
                rollback_when: {
                  is_update_ok: {
                    "=": 1
                  }
                }
              })
          )
        }
      })
    }

    ///2、修改订单明细剩余数量
    if (_params.update_valid_data && !_.isNull(_params.update_valid_data)) {
      let update_soline_biz_data = new biz_data_helper.base_entity_helper(
        "update_sl_validremain",
        {},
        {}
      )
      _actions.push(
        update_soline_biz_data
          .execAction({
            params: {
              SalesLineId: _params.update_valid_data.id
            },
            fields: ["valid_remain", "valid_approve"]
          })
          .action({})
      )
    }
    //3、生成采购单
    if (_params.purch_data && !_.isNull(_params.purch_data)) {
      if (_params.purch_data.main.length > 0) {
        const purch_code_biz_data = new biz_data_helper.base_entity_helper(
          "get_seq",
          {},
          {}
        )

        const purch_biz_data = new biz_data_helper.base_entity_helper(
          "PurchTable",
          {},
          {}
        )
        const purch_item_biz_data = new biz_data_helper.base_entity_helper(
          "PurchLine",
          {},
          {}
        )
        //获取code
        let _p = {
          type: "CPO",
          date: _date.format(new Date(), "yyyy-MM-dd")
        }
        _.each(_params.purch_data.main, t => {
          let _mt = _.cloneDeep(t)
          delete _mt.id
          _actions.push(
            purch_code_biz_data
              .execAction({
                params: _p,
                fields: ["seq"]
              })
              .action({
                output_last_item_map: {
                  seq: "PurchId"
                },
                skip_when: {
                  is_all_approved: { "=": false }
                }
              })
          )
          _actions.push(
            purch_biz_data
              .insertAction({
                params: _mt,
                fields: ["id"]
              })
              .action({
                output_last_item_map: {
                  id: "PurchaseOrderId"
                },
                mixin_last_item_map: {
                  PurchId: "PurchId"
                },
                skip_when: {
                  is_all_approved: { "=": false }
                }
              })
          )
          let _items = _.filter(_params.purch_data.items, {
            OrderAccount: t.OrderAccount
          })
          _.each(_items, m => {
            let _ml = _.cloneDeep(m)
            delete _ml.id
            delete _ml.OrderAccount
            _actions.push(
              purch_item_biz_data
                .insertAction({
                  params: _ml,
                  fields: ["id"]
                })
                .action({
                  mixin_last_item_map: {
                    PurchaseOrderId: "PurchaseOrderId"
                  },
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
          })
        })
      }

      if (_params.purch_data.update_list.length > 0) {
        const purch_update_biz_data = new biz_data_helper.base_entity_helper(
          "update_purch",
          {},
          {}
        )
        _.each(_params.purch_data.update_list, t => {
          _actions.push(
            purch_update_biz_data
              .execAction({
                params: t
              })
              .action({
                skip_when: {
                  is_all_approved: { "=": false }
                }
              })
          )
        })
      }
    }
    //4、调用AX
    if (_params.ax_data &&
      !_.isNull(_params.ax_data) &&
      !_.isEmpty(_params.ax_data.jsonGroupData)
    ) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      for (var i in _params.ax_data.jsonGroupData) {
        let _jsonData = _params.ax_data.jsonGroupData[i]
        if (_jsonData.length > 0) {
          let _p = {
            company: _params.ax_data.company,
            method: "CMOrderLines",
            jsonData: _jsonData
          }
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                },
                output_result_data_code: "AXParams",
                skip_when: {
                  is_all_approved: { "=": false }
                }
              })
          )
          ///只有审核时才修改派单信息
          if (_params.state) {
            let dispatch_biz_data = new biz_data_helper.base_entity_helper(
              "update_dispatch_ax_data",
              {},
              {}
            )
            _actions.push(
              dispatch_biz_data
                .execAction({
                  params: {},
                  fields: ["id"]
                })
                .action({
                  mixin_result_data_map: {
                    AXParams: "resultData[0][0].data"
                  },
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
          }
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                // rollback_when: {
                //   ax_interface_status: {
                //     "<>": 0
                //   }
                // },
                mixin_last_item_map: {
                  ax_interface_status: "ax_interface_status"
                },
                skip_when: {
                  is_all_approved: { "=": false }
                }
              })
          )
        }
      }
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      //如果不是全部审批，则不调用ax
      let is_all_approved = false
      let _check_is_all_approved = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_approve_status"
      })
      _.each(_check_is_all_approved, t => {
        if (
          t.Result &&
          t.Result.Data &&
          t.Result.Data[0] &&
          t.Result.Data[0].length > 0 &&
          !t.Result.Data[0][0].is_all_approved
        ) {
          is_all_approved = true
        }
      })
      if (is_all_approved) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      }
      //检查订单是否审核
      //ax 返回
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Params && t.Params.length > 0) {
          for (var i in t.Params) {
            if (t.Params[i].ax_interface_status != 0) {
              _is_ok = false
            }
          }
        }
        // if (t.Result && t.Result.Rollback == true) {
        //   _is_ok = false;
        // }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        ///记录ax调用失败日志
        let ep = {
          params: JSON.stringify(_actions),
          error_msg: _msg,
          result: JSON.stringify(_rdata)
        }
        common_controller.methods.createAXErorrLog(
          "error_ax_interface_CMOrderLines",
          ep
        )
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },

  async approveListData(_paramsList, log_data = null) {
    //1、审核派单
    //2、修改订单明细剩余数量
    //3、生成采购单
    //4、调用AX
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    let approved_biz_data = new biz_data_helper.base_entity_helper(
      "update_sPlant_SalesOrder_Dispatch",
      {},
      {}
    )
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      {},
      {}
    )
    let _actions = []
    // debugger
    // console.log("_paramsList", _paramsList)
    _.each(_paramsList, _params => {
      //1、审核派单
      if (_params.approve_data && !_.isNull(_params.approve_data)) {
        _.each(_params.approve_data, t => {
          _actions.push(
            update_status_biz_data
              .execAction({
                params: {
                  IsApproved: t.is_approved == true ? 1 : 0,
                  ApproveBy: t.username,
                  status_id: t.id,
                  ApproveRemark: t.ApproveRemark //审批备注
                },
                fields: ["is_update_ok", "is_all_approved"]
              })
              .action({
                output_last_item_map: {
                  is_update_ok: "is_update_ok",
                  is_all_approved: "is_all_approved"
                },
                rollback_when: {
                  isApproved: {
                    "=": false
                  }
                }
              })
          )

          if (!t.is_approved) {
            let _x = {
              SODispatchId: t.order_dispatch_id,
              CreateBy: t.userId,
              // is_approved: t.is_approved
              IsEmailSend: 0
            }
            _actions.push(
              approved_biz_data
                .execAction({
                  params: _x
                })
                .action({
                  rollback_when: {
                    is_update_ok: {
                      "=": 1
                    }
                  }
                })
            )
          }
        })
      }

      let update_soline_biz_data = new biz_data_helper.base_entity_helper(
        "update_sl_validremain",
        {},
        {}
      )
      ///2、修改订单明细剩余数量
      if (_params.update_valid_data && !_.isNull(_params.update_valid_data)) {
        if (_params.update_valid_data.length > 0) {
          _.each(_params.update_valid_data, t => {
            _actions.push(
              update_soline_biz_data
                .execAction({
                  params: {
                    SalesLineId: t.id
                  },
                  fields: ["valid_remain", "valid_approve"]
                })
                .action({})
            )
          })
        }
      }
      ///先默认修改为异常
      if (_params.state && _params.update_dispatch_data && !_.isNull(_params.update_dispatch_data)) {
        _actions.push(
          item_biz_data.updateAction({
            params: _params.update_dispatch_data
          }).action({})
        )
      }
      //3、生成采购单
      if (_params.purch_data && !_.isNull(_params.purch_data)) {
        if (_params.purch_data.main.length > 0) {
          const purch_code_biz_data = new biz_data_helper.base_entity_helper(
            "get_seq",
            {},
            {}
          )

          const purch_biz_data = new biz_data_helper.base_entity_helper(
            "PurchTable",
            {},
            {}
          )
          const purch_item_biz_data = new biz_data_helper.base_entity_helper(
            "PurchLine",
            {},
            {}
          )
          //获取code
          let _p = {
            type: "CPO",
            date: _date.format(new Date(), "yyyy-MM-dd")
          }
          _.each(_params.purch_data.main, t => {
            let _mt = _.cloneDeep(t)
            delete _mt.id
            _actions.push(
              purch_code_biz_data
                .execAction({
                  params: _p,
                  fields: ["seq"]
                })
                .action({
                  output_last_item_map: {
                    seq: "PurchId"
                  },
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
            _actions.push(
              purch_biz_data
                .insertAction({
                  params: _mt,
                  fields: ["id"]
                })
                .action({
                  output_last_item_map: {
                    id: "PurchaseOrderId"
                  },
                  mixin_last_item_map: {
                    PurchId: "PurchId"
                  },
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
            let _items = _.filter(_params.purch_data.items, {
              OrderAccount: t.OrderAccount
            })
            _.each(_items, m => {
              let _ml = _.cloneDeep(m)
              delete _ml.id
              delete _ml.OrderAccount
              _actions.push(
                purch_item_biz_data
                  .insertAction({
                    params: _ml,
                    fields: ["id"]
                  })
                  .action({
                    mixin_last_item_map: {
                      PurchaseOrderId: "PurchaseOrderId"
                    },
                    skip_when: {
                      is_all_approved: { "=": false }
                    }
                  })
              )
            })
          })
        }

        if (_params.purch_data.update_list.length > 0) {
          const purch_update_biz_data = new biz_data_helper.base_entity_helper(
            "update_purch",
            {},
            {}
          )
          _.each(_params.purch_data.update_list, t => {
            _actions.push(
              purch_update_biz_data
                .execAction({
                  params: t
                })
                .action({
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
          })
        }
      }

      //4、调用AX

      if (_params.ax_data &&
        !_.isNull(_params.ax_data) &&
        !_.isEmpty(_params.ax_data.jsonGroupData)
      ) {
        const h_biz_data = new biz_data_helper.base_entity_helper(
          "interface_invoke",
          {},
          {}
        )
        const x_biz_data = new biz_data_helper.base_entity_helper(
          "checkinterfaceresult",
          {},
          {}
        )
        for (var i in _params.ax_data.jsonGroupData) {
          let _jsonData = _params.ax_data.jsonGroupData[i]
          if (_jsonData.length > 0) {
            let _p = {
              company: _params.ax_data.company,
              method: "CMOrderLines",
              jsonData: _jsonData
            }
            _actions.push(
              h_biz_data
                .handlerAction({
                  params: _p
                })
                .action({
                  output_last_item_map: {
                    status: "ax_interface_status"
                  },
                  output_result_data_code: "AXParams",
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
            ///只有审核时才修改派单信息
            if (_params.state) {
              let dispatch_biz_data = new biz_data_helper.base_entity_helper(
                "update_dispatch_ax_data",
                {},
                {}
              )
              _actions.push(
                dispatch_biz_data
                  .execAction({
                    params: {},
                    fields: ["id"]
                  })
                  .action({
                    mixin_result_data_map: {
                      AXParams: "resultData[0][0].data"
                    },
                    skip_when: {
                      is_all_approved: { "=": false }
                    }
                  })
              )
            }
            _actions.push(
              x_biz_data
                .checkAction({
                  params: {}
                })
                .action({
                  // rollback_when: {
                  //   ax_interface_status: {
                  //     "<>": 0
                  //   }
                  // },
                  mixin_last_item_map: {
                    ax_interface_status: "ax_interface_status"
                  },
                  skip_when: {
                    is_all_approved: { "=": false }
                  }
                })
            )
          }
        }
      }
    })

    // console.log("_actions", _actions)
    let result = await api.query_batch({
      actions: _actions
    }, log_data)

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      //如果不是全部审批，则不调用ax
      let is_all_approved = false
      let _check_is_all_approved = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_approve_status"
      })
      _.each(_check_is_all_approved, t => {
        if (
          t.Result &&
          t.Result.Data &&
          t.Result.Data[0] &&
          t.Result.Data[0].length > 0 &&
          !t.Result.Data[0][0].is_all_approved
        ) {
          is_all_approved = true
        }
      })
      if (is_all_approved) {
        return {
          state: true,
          data: [],
          message: ""
        }
      }
      //检查订单是否审核
      //ax 返回
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Params && t.Params.length > 0) {
          for (var i in t.Params) {
            if (t.Params[i].ax_interface_status != 0) {
              _is_ok = false
            }
          }
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = t.Result.Data[0][0].message
          }
        })
        ///记录ax调用失败日志
        let ep = {
          params: JSON.stringify(_actions),
          error_msg: _msg,
          result: JSON.stringify(_rdata)
        }
        common_controller.methods.createAXErorrLog(
          "error_ax_interface_CMOrderLines",
          ep
        )
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },

  async refuseList(_params) {
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "refuse_approve_status",
      {},
      {}
    )
    let result = await update_status_biz_data
      .execAction({
        params: _params,
        fields: []
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data
    ) {
      return {
        state: true,
        data: [],
        message: ""
      }
    } else {
      return null
    }
  },
  //处理异常
  async handleAxException(_params) {
    let _actions = []
    if (_params.update_sod_data.length > 0) {
      let item_biz_data = new biz_data_helper.base_entity_helper(
        "sPlant_SalesOrder_Dispatch",
        create,
        descriptor
      )
      _actions.push(
        item_biz_data
          .updateAction({
            params: _params.update_sod_data,
            fields: ["id"]
          })
          .action({})
      )
    }

    //调用AX
    if (
      !_.isNull(_params.ax_data) &&
      !_.isEmpty(_params.ax_data.jsonGroupData)
    ) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      for (var i in _params.ax_data.jsonGroupData) {
        let _jsonData = _params.ax_data.jsonGroupData[i]
        if (_jsonData.length > 0) {
          let _p = {
            company: _params.ax_data.company,
            method: "CMOrderLines",
            jsonData: _jsonData
          }
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                },
                output_result_data_code: "AXParams",
              })
          )
          ///只有审核时才修改派单信息
          // if (_params.state) {
          let dispatch_biz_data = new biz_data_helper.base_entity_helper(
            "update_dispatch_ax_data",
            {},
            {}
          )
          _actions.push(
            dispatch_biz_data
              .execAction({
                params: {},
                fields: ["id"]
              })
              .action({
                mixin_result_data_map: {
                  AXParams: "resultData[0][0].data"
                },
              })
          )
          // }
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                rollback_when: {
                  ax_interface_status: {
                    "<>": 0
                  }
                }
              })
          )
        }
      }
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      //检查订单是否审核
      //ax 返回
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = []
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = _.map(t.Result.Data, (m) => {
              return m[0].message
            })
          }
        })
        ///记录ax调用失败日志
        let ep = {
          params: JSON.stringify(_actions),
          error_msg: _.join(_msg, " "),
          result: JSON.stringify(_rdata)
        }
        common_controller.methods.createAXErorrLog(
          "error_ax_interface_CMOrderLines",
          ep
        )
        return {
          state: false,
          data: [],
          message: _.join(_msg, " ")
        }
      }
    } else {
      return null
    }
  },

  ///del dispatch
  async deleteData(items, validForm, ax_params, vm) {
    let _actions = []

    let del_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      create,
      descriptor
    )
    let purch_delete_biz_data = new biz_data_helper.base_entity_helper(
      "delete_purch",
      {},
      {}
    )
    let check_dispatch_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesOrderDispatch",
      {},
      {}
    )
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sl_validremain",
      {},
      {}
    )
    let cancel_email_biz_data = new biz_data_helper.base_entity_helper(
      "cancel_email_send",
      {},
      {}
    )
    _.each(items, t => {
      _actions.push(
        check_dispatch_biz_data
          .execAction({
            params: {
              SalesLineId: t.SalesLineId,
              CurrentDispathId: t.id,
              action: "delete",
              inputQty: t.qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            }
          })
      )
      _actions.push(
        del_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )

      _actions.push(
        purch_delete_biz_data
          .execAction({
            params: {
              OrderDispatch_id: t.id
            }
          })
          .action({})
      )

      ///取消邮件
      _actions.push(
        cancel_email_biz_data
          .execAction({
            params: {
              type: "sod",
              idx: _.toString(t.id)
            }
          })
          .action({})
      )
    })
    console.log(validForm)
    ///修改订单明细
    if (validForm && validForm.length > 0) {
      _.each(validForm, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SalesLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }

    //4、调用AX
    if (!_.isNull(ax_params) && !_.isEmpty(ax_params.jsonGroupData)) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      for (var i in ax_params.jsonGroupData) {
        let _jsonData = ax_params.jsonGroupData[i]
        if (_jsonData.length > 0) {
          let _p = {
            company: ax_params.company,
            method: "CMOrderLines",
            jsonData: _jsonData
          }
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                }
              })
          )
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                rollback_when: {
                  ax_interface_status: {
                    "<>": 0
                  }
                }
              })
          )
        }
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///获取判定是否能够删除的检查结果
      let _check_del_dt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/d/sPlant_SalesOrder_Dispatch"
      })
      let _is_check_del_ok = true
      if (_check_del_dt && _check_del_dt.length > 0) {
        _.each(_check_del_dt, t => {
          if (t.Result && t.Result.Rollback == true) {
            _is_check_del_ok = false
          }
        })
      }
      if (!_is_check_del_ok) {
        return {
          state: false,
          error_code: "plant",
          data: [],
          message: "删除失败！错误信息：不能删除已出库的派单！"
        }
      }
      ///判定AX执行结果
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = vm.$t("notify.ax_error") + "：" + t.Result.Data[0][0].message
          }
        })
        return {
          state: false,
          data: items,
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  //保存数据至派单表,修改订单列表明细上的数量
  ///仅修改平台及审批状态
  async updateDispatchPre(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_SalesOrder_Dispatch",
      create,
      descriptor
    )

    let check_dispatch_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesOrderDispatch",
      {},
      {}
    )
    let update_soline_biz_data = new biz_data_helper.base_entity_helper(
      "update_sl_validremain",
      {},
      {}
    )
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus_PurchasePrice",
      {},
      {}
    )

    let _actions = []
    for (var i in _params.save_data) {
      let data = _params.save_data[i]
      let _documentCreateByUsername = data.documentCreateByUsername
      let _is_internal = data.is_internal

      delete data.documentCreateByUsername
      delete data.is_internal

      _actions.push(
        check_dispatch_biz_data
          .execAction({
            params: {
              SalesLineId: data.SalesLineId,
              CurrentDispathId: data.id,
              action: "update",
              inputQty: data.qty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            }
          })
      )
      delete data.change_qty
      data.is_email_send = 0
      data.isAXError = false///重新保存的时候需要重新清理ax异常状态
      data.AXError = ""
      _actions.push(
        item_biz_data
          .updateAction({
            params: data,
            fields: ["id"]
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )
      ///审批
      let _DiffAmountCNY = 0, _MinusAmountCNY = 0, _LastDiffAmountCNY = 0
      _DiffAmountCNY = Math.abs(data.price - data.price_vend) * data.qty
      _MinusAmountCNY = Math.abs(data.price_vend - data.Sales_Order_Price) * data.qty
      _LastDiffAmountCNY = Math.abs(data.price - data.Sales_Cost) * data.qty
      let credit_form = {
        ItemId: data.id,
        DocumentType: "SalesOrderDispatch",
        ApproveType: "", //审批类型："" ---普通审批
        DocumentCreateBy: _documentCreateByUsername,
        purch_price: data.price ? data.price : 0,
        initial_purch_price: data.price_vend ? data.price_vend : 0,
        sales_price: data.Sales_Order_Price ? data.Sales_Order_Price : 0,
        sales_cost: data.Sales_Cost ? data.Sales_Cost : 0,
        DiffAmountCNY: _DiffAmountCNY,
        MinusAmountCNY: _MinusAmountCNY,
        LastDiffAmountCNY: _LastDiffAmountCNY,
        is_internal: _is_internal
      }
      _actions.push(
        so_approve_biz_data
          .execAction({
            params: credit_form,
            fields: ["id"]
          })
          .action({})
      )
    }
    //修改订单明细
    if (
      _params.update_soline_form_list &&
      _params.update_soline_form_list.length > 0
    ) {
      _.each(_params.update_soline_form_list, t => {
        _actions.push(
          update_soline_biz_data
            .execAction({
              params: {
                SalesLineId: t.id
              },
              fields: ["valid_remain", "valid_approve"]
            })
            .action({})
        )
      })
    }
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      //获取判定是否能够修改的检查结果
      let _check_update_dt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/u/sPlant_SalesOrder_Dispatch"
      })
      let _is_check_update_ok = true
      if (_check_update_dt && _check_update_dt.length > 0) {
        _.each(_check_update_dt, t => {
          if (t.Result && t.Result.Rollback == true) {
            _is_check_update_ok = false
          }
        })
      }
      if (!_is_check_update_ok) {
        return {
          state: false,
          data: [],
          message:
            "保存失败！错误信息：派单数量不能超过剩余派单数量和剩余送货数量！"
        }
      }
      return {
        state: true,
        data: result.data.BatchResult.Actions,
        message: ""
      }
    } else {
      return null
    }
  },
  async updateDispatch(_params) {
    //修改采购单明细除开采购数量（采购数量从ax返回中获取）
    const up_purch_biz_data = new biz_data_helper.base_entity_helper(
      "PurchLine",
      {},
      {}
    )

    let _actions = []
    for (var i in _params.save_data) {
      let data = _params.save_data[i]
      delete data.documentCreateByUsername
      delete data.is_internal
      if (
        !_.isNull(_params.ax_params) &&
        !_.isEmpty(_params.ax_params.jsonGroupData)
      ) {
        ///查询采购单明细id
        _actions.push(
          up_purch_biz_data
            .selectAction({
              params: {
                is_deleted: 0,
                OrderDispatch_id: data.id
              },
              fields: ["id"]
            })
            .action({
              output_last_item_map: {
                id: "purch_item_id"
              }
            })
        )
        _actions.push(
          up_purch_biz_data
            .updateAction({
              params: {
                id: "",
                PurchPrice: data.price,
                DeliveryDate: data.delivery_date
              },
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                id: "purch_item_id"
              }
            })
        )
      }
    }

    //调用ax接口
    if (
      !_.isNull(_params.ax_params) &&
      !_.isEmpty(_params.ax_params.jsonGroupData)
    ) {
      const h_biz_data = new biz_data_helper.base_entity_helper(
        "interface_invoke",
        {},
        {}
      )
      const x_biz_data = new biz_data_helper.base_entity_helper(
        "checkinterfaceresult",
        {},
        {}
      )
      for (var i in _params.ax_params.jsonGroupData) {
        let _jsonData = _params.ax_params.jsonGroupData[i]
        if (_jsonData.length > 0) {
          let _p = {
            company: _params.ax_params.company,
            method: "CMOrderLines",
            jsonData: _jsonData
          }
          _actions.push(
            h_biz_data
              .handlerAction({
                params: _p
              })
              .action({
                output_last_item_map: {
                  status: "ax_interface_status"
                },
                output_result_data_code: "AXParams"
              })
          )
          _actions.push(
            x_biz_data
              .checkAction({
                params: {}
              })
              .action({
                mixin_last_item_map: {
                  ax_interface_status: "ax_interface_status"
                },
              })
          )

          //修改采购单明细
          const up_from_ax_purch_biz_data = new biz_data_helper.base_entity_helper(
            "update_PurchLine",
            {},
            {}
          )

          _actions.push(
            up_from_ax_purch_biz_data
              .execAction({
                params: {}
              })
              .action({
                mixin_result_data_map: {
                  AXParams: "resultData[0][0].data"
                }
              })
          )
        }
      }
    }

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      ///检查ax调用情况
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Params && t.Params.length > 0) {
          for (var i in t.Params) {
            if (t.Params[i].ax_interface_status != 0) {
              _is_ok = false
            }
          }
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = "AX接口调用失败，错误信息：" + t.Result.Data[0][0].message
          }
        })
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  // async updateDispatch(_params) {
  //   let item_biz_data = new biz_data_helper.base_entity_helper(
  //     "sPlant_SalesOrder_Dispatch",
  //     create,
  //     descriptor
  //   );
  //   // let update_soline_biz_data = new biz_data_helper.base_entity_helper(
  //   //   "SalesLine",
  //   //   {},
  //   //   {}
  //   // );

  //   let check_dispatch_biz_data = new biz_data_helper.base_entity_helper(
  //     "CheckIfCanModifySalesOrderDispatch",
  //     {},
  //     {}
  //   );
  //   //修改采购单明细除开采购数量（采购数量从ax返回中获取）
  //   const up_purch_biz_data = new biz_data_helper.base_entity_helper(
  //     "PurchLine",
  //     {},
  //     {}
  //   );
  //   let update_soline_biz_data = new biz_data_helper.base_entity_helper(
  //     "update_sl_validremain",
  //     {},
  //     {}
  //   );
  //   let so_approve_biz_data = new biz_data_helper.base_entity_helper(
  //     "sp_updateApproveStatus_PurchasePrice",
  //     {},
  //     {}
  //   );

  //   let _actions = [];
  //   for (var i in _params.save_data) {

  //     let data = _params.save_data[i];
  //     let _documentCreateByUsername = data.documentCreateByUsername;
  //     let _is_internal = data.is_internal;

  //     delete data.documentCreateByUsername;
  //     delete data.is_internal;

  //     _actions.push(
  //       check_dispatch_biz_data
  //         .execAction({
  //           params: {
  //             SalesLineId: data.SalesLineId,
  //             CurrentDispathId: data.id,
  //             action: "update",
  //             inputQty: data.qty
  //           },
  //           fields: ["allowed"]
  //         })
  //         .action({
  //           output_last_item_map: {
  //             allowed: "allowed"
  //           }
  //         })
  //     );
  //     delete data.change_qty;
  //     data.is_email_send = 0;
  //     data.isAXError = false;///重新保存的时候需要重新清理ax异常状态
  //     data.AXError = "";
  //     _actions.push(
  //       item_biz_data
  //         .updateAction({
  //           params: data,
  //           fields: ["id"]
  //         })
  //         .action({
  //           rollback_when: {
  //             allowed: {
  //               "=": false
  //             }
  //           }
  //         })
  //     );
  //     ///审批
  //     let _DiffAmountCNY = 0, _MinusAmountCNY = 0, _LastDiffAmountCNY = 0;
  //     _DiffAmountCNY = Math.abs(data.price - data.price_vend) * data.qty;
  //     _MinusAmountCNY = Math.abs(data.price_vend - data.Sales_Order_Price) * data.qty;
  //     _LastDiffAmountCNY = Math.abs(data.price - data.Sales_Cost) * data.qty;
  //     let credit_form = {
  //       ItemId: data.id,
  //       DocumentType: "SalesOrderDispatch",
  //       ApproveType: "", //审批类型："" ---普通审批
  //       DocumentCreateBy: _documentCreateByUsername,
  //       purch_price: data.price ? data.price : 0,
  //       initial_purch_price: data.price_vend ? data.price_vend : 0,
  //       sales_price: data.Sales_Order_Price ? data.Sales_Order_Price : 0,
  //       sales_cost: data.Sales_Cost ? data.Sales_Cost : 0,
  //       DiffAmountCNY: _DiffAmountCNY,
  //       MinusAmountCNY: _MinusAmountCNY,
  //       LastDiffAmountCNY: _LastDiffAmountCNY,
  //       is_internal: _is_internal
  //     };
  //     _actions.push(
  //       so_approve_biz_data
  //         .execAction({
  //           params: credit_form,
  //           fields: ["id"]
  //         })
  //         .action({})
  //     );

  //     if (
  //       !_.isNull(_params.ax_params) &&
  //       !_.isEmpty(_params.ax_params.jsonGroupData)
  //     ) {
  //       ///查询采购单明细id
  //       _actions.push(
  //         up_purch_biz_data
  //           .selectAction({
  //             params: {
  //               is_deleted: 0,
  //               OrderDispatch_id: data.id
  //             },
  //             fields: ["id"]
  //           })
  //           .action({
  //             output_last_item_map: {
  //               id: "purch_item_id"
  //             }
  //           })
  //       );
  //       _actions.push(
  //         up_purch_biz_data
  //           .updateAction({
  //             params: {
  //               id: "",
  //               PurchPrice: data.price,
  //               DeliveryDate: data.delivery_date
  //             },
  //             fields: ["id"]
  //           })
  //           .action({
  //             mixin_last_item_map: {
  //               id: "purch_item_id"
  //             }
  //           })
  //       );
  //     }
  //   }
  //   //修改订单明细
  //   if (
  //     _params.update_soline_form_list &&
  //     _params.update_soline_form_list.length > 0
  //   ) {
  //     _.each(_params.update_soline_form_list, t => {
  //       _actions.push(
  //         update_soline_biz_data
  //           .execAction({
  //             params: {
  //               SalesLineId: t.id
  //             },
  //             fields: ["valid_remain", "valid_approve"]
  //           })
  //           .action({})
  //       );
  //     });
  //   }

  //   //调用ax接口
  //   if (
  //     !_.isNull(_params.ax_params) &&
  //     !_.isEmpty(_params.ax_params.jsonGroupData)
  //   ) {
  //     const h_biz_data = new biz_data_helper.base_entity_helper(
  //       "interface_invoke",
  //       {},
  //       {}
  //     );
  //     const x_biz_data = new biz_data_helper.base_entity_helper(
  //       "checkinterfaceresult",
  //       {},
  //       {}
  //     );
  //     // console.log(_params.ax_params.jsonData);
  //     for (var i in _params.ax_params.jsonGroupData) {
  //       let _jsonData = _params.ax_params.jsonGroupData[i];
  //       if (_jsonData.length > 0) {
  //         let _p = {
  //           company: _params.ax_params.company,
  //           method: "CMOrderLines",
  //           jsonData: _jsonData
  //         };
  //         _actions.push(
  //           h_biz_data
  //             .handlerAction({
  //               params: _p
  //             })
  //             .action({
  //               output_last_item_map: {
  //                 status: "ax_interface_status"
  //               },
  //               output_result_data_code: "AXParams"
  //             })
  //         );
  //         _actions.push(
  //           x_biz_data
  //             .checkAction({
  //               params: {}
  //             })
  //             .action({
  //               // rollback_when: {
  //               //   ax_interface_status: {
  //               //     "<>": 0
  //               //   }
  //               // }
  //               mixin_last_item_map: {
  //                 ax_interface_status: "ax_interface_status"
  //               },
  //             })
  //         );

  //         //修改采购单明细
  //         const up_from_ax_purch_biz_data = new biz_data_helper.base_entity_helper(
  //           "update_PurchLine",
  //           {},
  //           {}
  //         );

  //         _actions.push(
  //           up_from_ax_purch_biz_data
  //             .execAction({
  //               params: {}
  //             })
  //             .action({
  //               mixin_result_data_map: {
  //                 AXParams: "resultData[0][0].data"
  //               }
  //             })
  //         );
  //       }
  //     }
  //   }

  //   let result = await api.query_batch({
  //     actions: _actions
  //   });

  //   if (
  //     result &&
  //     result.data &&
  //     result.data.BatchResult &&
  //     result.data.BatchResult.Actions &&
  //     result.data.BatchResult.Actions.length > 0
  //   ) {
  //     //获取判定是否能够修改的检查结果
  //     let _check_update_dt = _.filter(result.data.BatchResult.Actions, {
  //       Code: "data/u/sPlant_SalesOrder_Dispatch"
  //     });
  //     let _is_check_update_ok = true;
  //     if (_check_update_dt && _check_update_dt.length > 0) {
  //       _.each(_check_update_dt, t => {
  //         if (t.Result && t.Result.Rollback == true) {
  //           _is_check_update_ok = false;
  //         }
  //       });
  //     }
  //     if (!_is_check_update_ok) {
  //       return {
  //         state: false,
  //         data: [],
  //         message:
  //           "保存失败！错误信息：派单数量不能超过剩余派单数量和剩余送货数量！"
  //       };
  //     }
  //     ///检查ax调用情况
  //     let _rt = _.filter(result.data.BatchResult.Actions, {
  //       Code: "data/x/checkinterfaceresult"
  //     });
  //     let _rdata = _.filter(result.data.BatchResult.Actions, {
  //       Code: "data/h/interface_invoke"
  //     });
  //     let _is_ok = true;
  //     _.each(_rt, t => {
  //       if (t.Params && t.Params.length > 0) {
  //         for (var i in t.Params) {
  //           if (t.Params[i].ax_interface_status != 0) {
  //             _is_ok = false;
  //           }
  //         }
  //       }
  //       // if (t.Result && t.Result.Rollback == true) {
  //       //   _is_ok = false;
  //       // }
  //     });
  //     if (_is_ok == true) {
  //       return {
  //         state: true,
  //         data: result.data.BatchResult.Actions,
  //         message: ""
  //       };
  //     } else {
  //       let _msg = "";
  //       _.each(_rdata, t => {
  //         if (
  //           !_.isNull(t.Result) &&
  //           t.Result.LastItem.ax_interface_status != 0
  //         ) {
  //           _msg = "AX接口调用失败，错误信息：" + t.Result.Data[0][0].message;
  //         }
  //       });
  //       return {
  //         state: false,
  //         data: [],
  //         message: _msg
  //       };
  //     }
  //   } else {
  //     return null;
  //   }
  // },
  ///仅仅修改附件
  async updateDispatchAccessory(params) {
    let item_biz_data = new biz_data_helper.base_entity_helper("sPlant_SalesOrder_Dispatch", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "edit" && params[k].length > 0) {
        _actions.push(
          item_biz_data.updateAction({
            params: params[k],
            fields: ["id"]
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let is_error = false
      _.each(result.data.BatchResult.Actions, (t) => {
        if (!t.Result.Data) {
          is_error = true
        }
      })
      if (is_error) return null
      else {
        let rt = { add: [], edit: [], delete: [] }
        _.each(result.data.BatchResult.Actions, (t) => {
          if (t.Code.indexOf("data/u/") > -1) rt.edit = t.Result.Data[0]
        })
        return rt
      }
    } else {
      return null
    }
  },
  ///检查订单是否审核
  async checkOrderIsApproved(_params) {
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckSOAllApproved",
      {},
      {}
    )
    let _actions = []
    ///检查订单是否审核
    _actions.push(
      check_biz_data
        .execAction({
          params: { itemId: _params.salesOrderId },
          fields: ["isApproved"]
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/CheckSOAllApproved"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Data.length > 0) {
          _is_ok = t.Result.Data[0][0].isApproved
        }
      })
      return {
        state: _is_ok,
        data: [],
        message: "订单已经反审，不能执行该操作！"
      }
    } else {
      return null
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export { biz_data, dataForm, fields, methods, rules };

